export const ERROR_CODE_MAP = {
  9: {
    description: "BMS communication failure",
    clearable: true,
    category: "BMS",
  },
  16: {
    description: "Over voltage when charging",
    clearable: true,
    category: "BMS",
  },
  17: {
    description: "Lock status detect failed",
    clearable: true,
    category: "LOCK",
  },
  18: { description: "Unlock fail", clearable: true, category: "LOCK" },
  19: { description: "Lock fail", clearable: true, category: "LOCK" },
  33: {
    description: "Wireless communication failed",
    clearable: true,
    category: "WIRELESS",
  },
  34: {
    description: "Over-temperature protection",
    clearable: true,
    category: "WIRELESS",
  },
  35: {
    description: "Over-current protection",
    clearable: true,
    category: "WIRELESS",
  },
  36: {
    description: "Adjustable power supply exception",
    clearable: false,
    category: "WIRELESS",
  },
};

export const getErrorDescription = (code) => {
  return ERROR_CODE_MAP[code]?.description || `Unknown error (${code})`;
};

export const isErrorClearable = (code) => {
  return ERROR_CODE_MAP[code]?.clearable ?? true;
};
